export { authProvider } from './authProvider';
export { dataProvider } from './dataProvider';

import firebase from "firebase/compat/app";
import "firebase/compat/firestore";

// Cache variables
let appStatusCache: { app_locked: boolean; admin_only: boolean } | null = null;
let lastAppStatusFetch = 0;
const APP_STATUS_CACHE_DURATION = 60 * 1000; // 1 minute cache

/**
 * Fetches the app status from Firestore and caches it for a short duration.
 * @returns {Promise<{ app_locked: boolean; admin_only: boolean }>} The app status object.
 */
export const getAppStatus = async (): Promise<{ app_locked: boolean; admin_only: boolean }> => {
    const now = Date.now();

    // Use cached value if it's still valid
    if (appStatusCache && now - lastAppStatusFetch < APP_STATUS_CACHE_DURATION) {
        return appStatusCache;
    }

    try {
        const db = firebase.firestore();
        const configDoc = await db.collection("config").doc("app_status").get();

        // Ensure a valid default structure
        appStatusCache = configDoc.exists && configDoc.data()
            ? (configDoc.data() as { app_locked: boolean; admin_only: boolean })
            : { app_locked: false, admin_only: false };

        lastAppStatusFetch = now;
        console.log("Fetched app_status from Firestore:", appStatusCache);
    } catch (error) {
        console.error("Error fetching app_status from Firestore:", error);
        appStatusCache = { app_locked: false, admin_only: false }; // Fallback values
    }

    return appStatusCache;
};